import type { CrosswordDoc } from './doc';

/**
 * ref → índice, espelhando `atribuirIndices()` (ramo estilo 3) do servidor em
 * `recreativa-api/src/modules/passatempos/domain/matrix-generator.ts`.
 *
 * A regra: ordena as casas mortas por (y, x) — desempate estável pela ordem do array,
 * equivalente ao `id` sintético (1..N na ordem do payload) que o servidor usa — e,
 * para cada casa, atribui `index++` a cada slot (palavra1Ref depois palavra2Ref) cujo
 * ref resolva para uma palavra. Ref que não resolve é ignorado (igual ao servidor).
 *
 * É a ÚNICA regra derivada do editor; o resto da matriz é trivialmente conhecido do
 * modelo autoral. Preview/save devolvem os `indices` do servidor para conferência.
 */
export function deriveIndices(doc: CrosswordDoc): Record<string, number> {
  const refs = new Set(doc.words.map((w) => w.ref));

  // Ordena por (y, x); a ordem original do array é o desempate estável — equivale ao
  // id sintético (i+1 na ordem do payload) que o servidor usa em `ordenarPorYX`.
  const ordered = doc.deadCells
    .map((cell, order) => ({ cell, order }))
    .sort((a, b) => a.cell.y - b.cell.y || a.cell.x - b.cell.x || a.order - b.order);

  const indices: Record<string, number> = {};
  let index = 1;
  for (const { cell } of ordered) {
    for (const ref of [cell.palavra1Ref, cell.palavra2Ref]) {
      if (ref == null || !refs.has(ref)) continue;
      indices[ref] = index++;
    }
  }
  return indices;
}
